import React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgRteOverflow = function SvgRteOverflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8 12a2 2 0 11-4.001-.001A2 2 0 018 12zm6 0a2 2 0 11-4.001-.001A2 2 0 0114 12zm6 0a2 2 0 11-4.001-.001A2 2 0 0120 12z"
  })));
};
var rteOverflow = SvgRteOverflow;

export { rteOverflow as default };
